import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

function Details() {
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: 'black',
                pt: 6,
                pb: 6,
            }}
        >
            <Container maxWidth="lg">
                <Grid container alignItems="center" spacing={4}>
                    {/* Content Section */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ color: 'white', textAlign: 'left' }}>
                            {/* Subtitle */}
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#1e88e5', // Blue color for subtitle
                                    fontWeight: 'bold',
                                    mb: 1,
                                }}
                            >
                                Hack the Cloud
                            </Typography>

                            {/* Heading */}
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                Hack the Cloud
                            </Typography>

                            {/* Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 2,
                                }}
                            >
                                Cloudathon is a dynamic and immersive competition that brings together technology enthusiasts 
                                and professionals to explore the limitless possibilities of cloud computing. 
                                Designed to challenge participants in both offensive and defensive scenarios, 
                                it pushes the boundaries of technical expertise through rapid innovation, and teamwork.
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 2,
                                }}
                            >
                                Cloudathon is more than just a competition—it's a platform for learning, 
                                collaboration, and showcasing mastery in cloud architecture and security.
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Video Section */}
                    <Grid item xs={12} sm={6}>
                        <Box>
                            <video
                                controls
                                preload="none" // Lazy loading: video file loads only when the user presses play
                                poster="/video/cloudathon-thumbnail.png" // Placeholder image before the video plays
                                style={{
                                    width: '100%',
                                    borderRadius: '8px',
                                }}
                            >
                                <source src="https://static-csn.s3.us-east-1.amazonaws.com/cloudathon.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Details;
